import type { Opportunity, OpportunitySubcategory } from "@api/opportunity";
import type { ColumnDef } from "./columnConfig";
import { useIsMobile } from "@/hooks/useResponsive";
import { OpportunityRow } from "./OpportunityRow";
import { AddOpportunityRow } from "./AddOpportunityRow";
import { OpportunityCard } from "./OpportunityCard";
import styles from "./styles.module.css";

type Props = {
  opportunities: Opportunity[];
  isAdmin: boolean;
  isAddingRow: boolean;
  onCancelAdd: () => void;
  selectedCategoryId: string;
  columns: ColumnDef[];
  categoryName: string;
  selectedSubcategory: string | null;
  subcategories: OpportunitySubcategory[];
};

export const OpportunityTable = ({
  opportunities,
  isAdmin,
  isAddingRow,
  onCancelAdd,
  selectedCategoryId,
  columns,
  categoryName,
  selectedSubcategory,
  subcategories,
}: Props) => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <div className={styles.cardList}>
        {opportunities.map((opp) => (
          <OpportunityCard
            key={opp.id}
            opportunity={opp}
            isAdmin={isAdmin}
            columns={columns}
            categoryName={categoryName}
            subcategories={subcategories}
          />
        ))}
      </div>
    );
  }

  return (
    <table aria-label="Opportunities table" className={styles.table}>
      <colgroup>
        {columns.map((col) => (
          <col key={col.field} width={col.width} />
        ))}
        {isAdmin && <col width="7%" />}
      </colgroup>
      <thead>
        <tr>
          {columns.map((col) => (
            <th key={col.field}>{col.header}</th>
          ))}
          {isAdmin && <th>Actions</th>}
        </tr>
      </thead>
      <tbody>
        {isAddingRow && (
          <AddOpportunityRow
            categoryId={selectedCategoryId}
            onCancel={onCancelAdd}
            columns={columns}
            categoryName={categoryName}
            defaultSubcategory={selectedSubcategory}
            subcategories={subcategories}
          />
        )}
        {opportunities.map((opp) => (
          <OpportunityRow
            key={opp.id}
            opportunity={opp}
            isAdmin={isAdmin}
            columns={columns}
            categoryName={categoryName}
            subcategories={subcategories}
          />
        ))}
      </tbody>
    </table>
  );
};
